/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

export default (): JSX.Element => (
  <svg width={65} height={45} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient
        x1="-6.589%"
        y1="57.608%"
        x2="178.488%"
        y2="57.608%"
        id="prefix__a"
      >
        <stop stopColor="#B2D4FF" stopOpacity={0} offset="0%" />

        <stop stopColor="#ADD1FF" stopOpacity={0.05} offset="9%" />

        <stop stopColor="#9FC9FF" stopOpacity={0.18} offset="25%" />

        <stop stopColor="#89BDFF" stopOpacity={0.4} offset="48%" />

        <stop stopColor="#6BACFF" stopOpacity={0.69} offset="74%" />

        <stop stopColor="#4C9AFF" offset="100%" />
      </linearGradient>
    </defs>

    <path
      d="M405 78.525h-6.727c-3.46-.02-6.574-2.134-7.912-5.372-.803-1.993-2.711-3.298-4.834-3.306-2.243.02-4.224 1.487-4.926 3.65-1.552 4.57-5.789 7.638-10.552 7.642h-24.455a5.536 5.536 0 01-4.085-1.786 5.707 5.707 0 01-1.496-4.25c.26-3.02 2.768-5.324 5.754-5.286h2.941v-4.912c0-8.728 6.972-15.803 15.572-15.803a11.4 11.4 0 013.266-8.007 11.067 11.067 0 017.89-3.314h18.874a11.067 11.067 0 017.89 3.314 11.348 11.348 0 012.8 4.765v32.665z"
      fill="url(#prefix__a)"
      transform="translate(-340 -37)"
    />
  </svg>
);
